import { SxProps, Theme } from '@mui/material';

export const containerStyles: SxProps<Theme> = {
  display: 'flex',
  minHeight: 'calc(100vh - 100px)',
  marginTop: "60px",
  width: "100vw",
  background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)',
};

export const mainContainerStyles: SxProps<Theme> = {
  width: '100%',
  maxWidth: '800px',
  margin: '0 auto',
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const leftPaneStyles = {
    width: '60%',
    borderRight: '1px solid #ccc',
    p: 2,
    display: 'flex',
    flexDirection: 'column',
  };
  
  export const rightPaneStyles = {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  };
  
  export const searchBoxStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginY: '20px',
    width: '100%',
    justifyContent: 'center',
  };
  
  export const searchInputStyles = {
    width: '400px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 1)',
      },
      '&.Mui-focused': {
        backgroundColor: 'rgba(255, 255, 255, 1)',
      },
    },
  };
  
  export const searchButtonStyles = {
    backgroundColor: 'primary.main',
    padding:'8px',
    color: 'white',
    '&:hover': {
      backgroundColor: 'primary.dark',
    },
  };
  
  export const loadingContainerStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    p: 2,
    justifyContent: 'center',
    width: '100%',
  };
  
  export const glassPaperStyles = {
    width: '100%',
    px: 4,
    py: 3,
    borderRadius: '20px',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    minHeight: '300px',
  };
  
  export const profileIdStyles = {
    mb: 2,
    color: 'primary.main',
    fontWeight: 'bold',
  };
  
  export const markdownContentStyles = {
    '& p': {
      marginBottom: '1rem',
      lineHeight: '1.6',
    },
    '& ul, & ol': {
      marginLeft: '2rem',
      marginBottom: '1rem',
    },
  };
  
  export const noProfileContainerStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
    width: '100%',
  };
  
  export const noProfilePaperStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    border: '1px solid rgba(255, 255, 255, 0.3)',
  };
  
  export const chatContainerStyles = {
    flex: 1,
    overflowY: 'auto',
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    paddingBottom: '80px',
    minHeight:"calc(100vh - 190px)"
  };
  
  export const messageInputStyles = {
    display: 'flex',
    gap: 1,
    p: 2,
    borderTop: '1px solid #eee',
    backgroundColor: 'white',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '80px',
  };
  
  export const collapseButtonStyles = {
    position: 'absolute',
    right: '40%',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    zIndex: 1,
  };
  
  export const chatPromptStyles: SxProps<Theme> = {
    position: 'fixed',
    bottom: '55px',
    right: '60px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    padding: '12px 20px',
    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 40px rgba(0, 0, 0, 0.15)',
    },
    zIndex: 1000,
  };
  
  export const chatPromptTextStyles: SxProps<Theme> = {
    color: 'primary.main',
    fontWeight: 500,
    fontSize: '0.9rem',
  };
  